import React from 'react'
import { Link } from 'react-router-dom';
function Mobile_program() {
  return (
    <div>
        <div className='container pt-4 mt-5'>
        <h1 className='display-5 text-center program_mobile_text pt-5'>Our Program</h1>
        <div className='row '>
            <div className='col-md-12 mb-4 mt-3'>
                <div className='mobile_Program_pop_up_text'>
                <h5 className='text-center'>Traineeship Program</h5>
                <p className='text-center'>Immerse in real-world challenges, gaining practical insights and honing your skills for a dynamic career journey.</p>
                </div>
                <div className='text-center'>
                <Link to='/Traineeship-program'><button  className="text-white shadow-sm fs-6 px-5 pt-1 pb-2 Navbar_button">View More</button></Link>
                </div>
            </div>
            <div className='col-md-12 border-top pt-4 pb-5'>
                <div className='mobile_Program_pop_up_text'>
                <h5 className='text-center'>Advance Program</h5>
                <p className='text-center'>Unleash your potential through our comprehensive programs, designed to propel your expertise to new heights </p>
                </div>
                <div className='text-center'>
                <Link to='/Advance-program'><button  className="text-white shadow-sm fs-6 px-5 pt-1 pb-2 Navbar_button">View More</button></Link>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Mobile_program
